import { media } from '@prisjakt/ui-base';
import { ButtonText } from '@prisjakt/ui/button';
import styled, { css } from 'styled-components';

export const StyledPill = styled.li`
  flex: 0;
  max-width: 250px;
  margin: 4px;
`;

export const StyledButtonText = styled(ButtonText)`
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  pointer-events: none;
`;

export const StyledPillbox = styled.ul<{
  $wrap: boolean;
  $wrapMobile: boolean;
}>(
  p => css`
    list-style: none;
    display: flex;
    flex-wrap: ${p.$wrap ? 'wrap' : 'nowrap'};
    overflow-x: ${p.$wrap ? 'visible' : 'auto'};

    ${media.smallOnly`
      flex-wrap: ${p.$wrapMobile ? 'wrap' : 'nowrap'};
      overflow-x: ${p.$wrapMobile ? 'visible' : 'auto'};
    `};
  `
);
